export default "__VITE_ASSET__BlCDQkyN__"